<template>
    <div class="waba-supsis-volume-based-pricing-tier-update">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2VolumeBasedPricingTierUpdated") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.event") }}</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.tier") }}</b>: {{ $_.get(activity, "payload.volume_tier_info.tier") }}</div>
            <div><b>{{ $t("auto.pricingCategory") }}</b>: {{ $_.get(activity, "payload.volume_tier_info.pricing_category") }}</div>
            <div><b>{{ $t("auto.effectiveMonth") }}</b>: {{ $_.get(activity, "payload.volume_tier_info.effective_month") }}</div>
            <div><b>{{ $t("auto.region") }}</b>: {{ $_.get(activity, "payload.volume_tier_info.region") }}</div>
            <div v-if="$_.get(activity, 'payload.volume_tier_info.tier_update_time')">
                <b>{{ $t("auto.updateTime") }}</b>: {{ formatTime($_.get(activity, "payload.volume_tier_info.tier_update_time")) }}
            </div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisVolumeBasedPricingTierUpdate",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
    methods: {
        formatTime(timestamp) {
            if (!timestamp) return "";
            const date = new Date(timestamp * 1000);
            return date.toLocaleString("tr-TR");
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-volume-based-pricing-tier-update {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
